import React, { useState } from 'react';
import withStyles from 'react-jss';
import { Button, Tooltip } from 'src/design-system/components/atoms';
import { ListNavIcon } from './icons/opsDashboard/ListNavIcon';
import { MapNavIcon } from './icons/opsDashboard/MapNavIcon';
import { ThemeType, CssType } from '@theming/jssTypes';

const styles = (theme: ThemeType): CssType => ({
  container: {
    marginLeft: theme.spacing[2],
  },
});

const SwitchMapListViewComponent = (props) => {
  const { classes, theme } = props;
  const isMapView = props.isMapView;

  const optionsList = [
    { label: 'map', value: true },
    { label: 'list', value: false },
  ];
  const iconStyle = { fontSize: theme.typography.fontSize.lg, verticalAlign: 'middle' };

  const getIconComponent = (view) => {
    switch (view) {
      case 'map':
        return (
          <Tooltip placement="bottom" title={'Switch to Map View'}>
            <MapNavIcon style={iconStyle} />
          </Tooltip>
        );
      case 'list':
        return (
          <Tooltip placement="bottom" title={'Switch to List View'}>
            <ListNavIcon style={iconStyle} />
          </Tooltip>
        );
      default:
        return null;
    }
  };
  const handleOnClick = (value) => {
    // if same option is being clicked
    if (value === isMapView) {
      return;
    }
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <div className={classes.container}>
      <Button.Group>
        {optionsList.map((option) => (
          <Button
            onClick={() => handleOnClick(option.value)}
            type={option.value === isMapView ? 'primary' : 'secondary'}
            style={{ display: 'flex', alignItems: 'center' }}
            key={option.value.toString()}
          >
            {getIconComponent(option.label)}
          </Button>
        ))}
      </Button.Group>
    </div>
  );
};

const SwitchMapListView = withStyles(styles, { injectTheme: true })(SwitchMapListViewComponent);

export default SwitchMapListView;
export { SwitchMapListView };
